﻿const { Swiper } = require("swiper");
const { Pagination } = require("swiper/modules");

const AdvantsCarousel = function (el) {
	Swiper.use([Pagination]);

	const swiper = new Swiper(el, {
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		speed: 400,
		spaceBetween: 16,
		slidesPerView: 2.1,
		centeredSlides: true,
		centeredSlidesBounds: true,
		breakpoints: {
			991: {
				slidesPerView: 5,
				centeredSlides: false,
				centeredSlidesBounds: false,
			},
		},
	});
};

module.exports = AdvantsCarousel;